import React from 'react';

import {
    BILLING_CYCLES,
    PLAN_TIERS,
    buildPlanKey,
    formatCurrency,
    getDisplayPrice,
    getTierDefinition,
} from '../../../subscription';

const VAT_PERCENT = 19;

export default function useLandingPageState() {
    const [showInclVat, setShowInclVat] = React.useState(false);
    const [billingCycle, setBillingCycle] = React.useState(BILLING_CYCLES.MONTHLY);
    const [cookieOpen, setCookieOpen] = React.useState(() => {
        if (typeof window === 'undefined') return true;
        return !localStorage.getItem('schreiberlein_cookies_ok');
    });

    const vatLabel = showInclVat ? `inkl. USt (${VAT_PERCENT} %)` : `zzgl. USt (${VAT_PERCENT} %)`;
    const invoiceNetMonthly = formatCurrency(
        getDisplayPrice(buildPlanKey(PLAN_TIERS.INVOICE, BILLING_CYCLES.MONTHLY), false)
    );
    const accountingNetMonthly = formatCurrency(
        getDisplayPrice(buildPlanKey(PLAN_TIERS.ACCOUNTING, BILLING_CYCLES.MONTHLY), false)
    );
    const invoiceFeatures = getTierDefinition(PLAN_TIERS.INVOICE).features;
    const isYearly = billingCycle === BILLING_CYCLES.YEARLY;

    const handleAcceptCookies = () => {
        localStorage.setItem('schreiberlein_cookies_ok', '1');
        setCookieOpen(false);
    };

    return {
        showInclVat,
        billingCycle,
        cookieOpen,
        vatLabel,
        invoiceNetMonthly,
        accountingNetMonthly,
        invoiceFeatures,
        isYearly,
        setShowInclVat,
        setBillingCycle,
        handleAcceptCookies,
    };
}
